import type {SuggestObject} from '@yandex-delivery/api/model/suggest'
import type {SuggestMode} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {defaultCoordinates} from '@yandex-delivery/order-form/src/actions/AddDestination/useAddDestinationAction'
import {useFormContext} from 'react-hook-form'

import {toUserAddressPin} from '../../../api/address/services/addressService/mappers'
import {getAddressDetails} from '../../../lib/get-address-details'

export function useSuggest() {
  const i18n = useI18n()
  const {watch} = useFormContext()

  const suggestMode: SuggestMode =
    watch('suggest_mode') || (watch('vertical_name') === 'cargo_intercity' ? 'delivery_intercity' : 'delivery_b2b')

  const addressSuggestPlaceholder =
    suggestMode === 'delivery_b2b'
      ? i18n('cargo.create.address.street_house', 'Улица, дом')
      : i18n('cargo.create.address.city_street_house', 'Город, улица, дом')

  function updateAddress({
    name,
    suggestValue,
    onChange,
  }: {
    name: string
    suggestValue?: SuggestObject
    onChange: (...event: any[]) => void
  }): void {
    const prevAddress = watch(name)
    const details = prevAddress ? getAddressDetails(prevAddress) : {}

    if (suggestValue) {
      const pointAddress = toUserAddressPin(suggestValue)
      onChange({...details, ...pointAddress})
    } else {
      // скидываем адрес в дефолтный бдуйный пустой адрес
      onChange({coordinates: defaultCoordinates, ...details})
    }
  }

  return {suggestMode, addressSuggestPlaceholder, updateAddress}
}
